import type { ErrorPolicyOutcome } from "../../utils/errorPolicy";

/**
 * Whether to log the failure to the console. In production builds, skips noise when Sentry capture
 * is off or the policy suppresses events (`sentryEvent === "none"`). Non-production always logs.
 */
export function shouldLogSagaErrorToConsole(
  policy: ErrorPolicyOutcome,
  captureInSentry: boolean,
): boolean {
  if (!import.meta.env.PROD) {
    return true;
  }
  if (!captureInSentry) {
    return false;
  }
  return policy.sentryEvent !== "none";
}

/**
 * User-visible string derived from a saga failure message.
 */
export function getFailureToastMessage(errorMessage: string): string {
  return errorMessage ? `Failed to load data: ${errorMessage}` : "Failed to load data";
}

/** Whether a failure action should trigger a toast after dispatch. */
export function shouldShowFailureToast(policy: ErrorPolicyOutcome): boolean {
  return policy.notifyUser;
}

/**
 * Stable message string for failure actions and policy resolution.
 */
export function getSagaErrorMessage(error: unknown): string {
  if (error instanceof Error) {
    return error.message;
  }
  if (typeof error === "string") {
    return error;
  }
  return "An unexpected error occurred.";
}
